import { Component, ElementRef, EventEmitter, HostListener, inject, Input, OnInit, Output } from '@angular/core';
import { I18nService } from './i18n.service';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
  standalone: false,
})
export class LanguageSelectorComponent implements OnInit {
  @Input() inNavbar = false;
  @Input() openAbove = false;
  @Output() selectedLanguage: EventEmitter<string> = new EventEmitter<string>();
  isDropdownOpen = false;
  protected readonly open = open;
  private readonly _i18nService = inject(I18nService);
  private readonly _eRef = inject(ElementRef);

  get currentLanguage(): string {
    const language = this._i18nService.language;
    const parts = language.split('-');
    return parts.length > 1 ? parts[1] : '';
  }

  get languages(): string[] {
    return this._i18nService.supportedLanguages;
  }

  ngOnInit() {
    setTimeout(() => {
      this.selectedLanguage.emit(this.currentLanguage.toLowerCase());
    }, 100);
    // this._i18nService.languageObservable.pipe(untilDestroyed(this)).subscribe(() => {
    //   this.selectedLanguage.emit(this.currentLanguage.toLowerCase());
    // });
  }

  /**
   * Listener to handle click events outside of the dropdown component.
   * Helps in closing the dropdown if clicked outside.
   */
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this._eRef?.nativeElement?.contains(event.target)) {
      this.isDropdownOpen = false;
    }
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  setLanguage(language: string) {
    this._i18nService.language = language;
    this.toggleDropdown();
  }

  getLanguageCode(language: string): string {
    const parts = language.split('-');
    return parts.length > 1 ? parts[1] : '';
  }
}
